import { combineReducers } from 'redux';

import knowledgeBase from './knowledgeBase';

export default combineReducers({
  knowledgeBase,
});
